import { gql } from '@apollo/client'

export const GET_COURSES = gql`
  query learningCourse($input: LearningActivityInput) {
    learningCourse(input: $input) {
      data {
        id
        name
        completion
        startDate
        endDate
        score
        timeSpent
        viewUrl
        launchUrl
        completionPercent
        section
        credits {
          type
          value
          creditYear
        }
        certificates {
          name
          url
          issueDate
          expiryDate
        }
        badges {
          image_url
        }
      }
      meta {
        count
        page
        pageSize
        totalPages
      }
    }
  }
`

export const GET_CERTIFICATES = gql`
  query courseCertificates($input: LearningActivityInput) {
    courseCertificates(input: $input) {
      data {
        title
      }
    }
  }
`

export const GET_WEBINARS = gql`
  query webinars($input: LearningActivityInput) {
    webinars(input: $input) {
      data {
        webinarId
        date
        title
        role
        url
      }
      meta {
        count
        page
        pageSize
        totalPages
      }
    }
  }
`

export const GET_CONFERENCES = gql`
  query conferences($input: LearningActivityInput) {
    conferences(input: $input) {
      data {
        eventName
        startDate
        endDate
        location
        productUrl
      }
      meta {
        count
        page
        pageSize
        totalPages
      }
    }
  }
`

export const GET_LEARNING_SUMMARY = gql`
  query learningSummary {
    learningSummary {
      data {
        id
        url
        title
        type
        date
      }
    }
  }
`
